<div class="kr-skeleton-wrapper"><div class="kr-skeleton kr-smart-button" :class="dynamicClasses"></div></div>